import { lazy } from 'react';

import { Loadable } from '../components/Loadable';
import { AuthLayout } from '../Layout/Auth';

const Login = Loadable(lazy(() => import('../pages/auth/Login')));
const Register = Loadable(lazy(() => import('../pages/auth/Register')));
const ForgotPassword = Loadable(
   lazy(() => import('../pages/auth/ForgotPassword'))
);
const ResetPassword = Loadable(
   lazy(() => import('../pages/auth/ResetPassword'))
);
const VerifyEmail = Loadable(lazy(() => import('../pages/auth/VerifyEmail')));

export const authRoutes = {
   path: '/',
   children: [
      {
         path: '/auth',
         element: <AuthLayout />,
         children: [
            { path: 'login', element: <Login /> },
            { path: 'register', element: <Register /> },
            { path: 'forgot-password', element: <ForgotPassword /> },
            {
               path: 'reset-password/:token/:email',
               element: <ResetPassword />,
            },
            {
               path: 'verify-email',
               element: <VerifyEmail />,
            },
         ],
      },
   ],
};

export default authRoutes;
